import { SchemaModifierBasePlainObject } from './schemaModifierBase.plainObject';

export class DerivePlainObject extends SchemaModifierBasePlainObject {
}
